import { Potluck, Shared } from "components/workflow/steps";
import { IFeedback, IPotluck, IUser } from "interfaces";

export const Steps = [
  Potluck.Details.default,
  Potluck.Schedule.default,
  Potluck.Message.default,
  Shared.Guest.default,
  Shared.Feedback.default,
  Potluck.Share.default,
];

export type PotluckType = { potluck: IPotluck, user: IUser, feedback: IFeedback };